// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button, Container, Divider } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
import toast from "react-hot-toast";


import { TableRow, TableCell } from "@mui/material";
import { voucherLineTypes } from "./Voucher.utils";
import GoInlineField from "../../../components/Inputs/GoInlineField";

const chequeFields = ["cheque_no_or_ref", "cheque_date", "cheque_type"];

const VoucherLine = ({ values, touched, errors, handleChange, voucherType, voucherId, voucherLineId, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [voucher_line, setVoucherLine] = useState(voucherLineTypes[voucherType].state);
    const [schema, setSchema] = useState(voucherLineTypes[voucherType].schema);
    const [formFields, setFormFields] = useState(voucherLineTypes[voucherType].formFields);
    const [depList, setDepList] = useState({
        mode_of_payes: [],
    });

    const makeDisabled = (name, disabled) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name
                    ? { ...field, disabled: disabled }
                    : field
            )
        );
    };

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleCommonCodeChange = async () => {
        spinService.on();
        const common_codes = "cheque_types";
        const response = await get(EntityConstants.COMMON_CODES, `types=${common_codes}`);
        const data = await response.json();
        attachOptions("cheque_type", data.cheque_types);
        spinService.off();
    };

    const handleAccountChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, "max=all");
        const data = await response.json();
        attachOptions("debit_ledger_id", data);
        attachOptions("credit_ledger_id", data);
        attachOptions("account_id", data);
        spinService.off();
    };

    const handleModeOfPayChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.MODE_OF_PAYES, "max=all");
        const data = await response.json();
        attachOptions("mode_of_pay_id", data);
        setDepList((prevState) => {
            return { ...prevState, mode_of_payes: data }
        });
        spinService.off();

    };

    const handleVoucherLineChange = async (voucherLineId) => {
        spinService.on();
        const response = await get(EntityConstants.VOUCHER_LINES + `/${voucherLineId}`);
        const data = await response.json();

        if (voucherType !== "Journal Voucher") {
            setVoucherLine(data);
        } else {
            jounralVoucherSetup(data);
        }
        spinService.off();
    };

    const jounralVoucherSetup = (voucherLine) => {
        setVoucherLine({
            id: voucherLine.id,
            narration: voucherLine.narration,
            account_id: voucherLine.debit_ledger_id === null ? voucherLine.credit_ledger_id : voucherLine.debit_ledger_id,
            credit_amount: voucherLine.credit_amount,
            debit_amount: voucherLine.debit_amount
        })
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewVoucherLine = values.id === undefined;
        if (isNewVoucherLine) {
            values.voucher_id = voucherId;
            values.type = voucherType;
        }
        const url = isNewVoucherLine ? EntityConstants.VOUCHER_LINES : EntityConstants.VOUCHER_LINES + `/${values.id}`;
        const method = isNewVoucherLine ? post : put;
        const response = await method(url, { voucher_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewVoucherLine ? MessageContants.VOUCHER_LINE_CREATED : MessageContants.VOUCHER_LINE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    const handleValueChange = (e, values) => {
        if (voucherType === "Payment Voucher" && e.target.name === "mode_of_pay_id") {
            let mode_of_pay = depList.mode_of_payes.find((mop) => mop.id === e.target.value).mode_of_pay;
            if (mode_of_pay === "Cash") {
                chequeFields.map((item) => {
                    if (schema.fields[item]) {
                        makeDisabled(item, true);
                        values[item] = null;
                        schema.fields[item] = schema.fields[item].nullable();
                        return setSchema(schema);
                    }
                });
            } else {
                chequeFields.map((item) => {
                    if (schema.fields[item]) {
                        makeDisabled(item, false);
                        schema.fields[item] = schema.fields[item].required();
                        return setSchema(schema);
                    }
                });
            }
        }
        if (voucherType !== "Payment Voucher") {
            if (e.target.name === "debit_amount") {
                makeDisabled("credit_amount", e.target.value !== "");
            }
            if (e.target.name === "credit_amount") {
                makeDisabled("debit_amount", e.target.value !== "");
            }
        }
        if (voucherType === "Payment Voucher" && e.target.name === "debit_amount") {
            values.credit_amount = e.target.value;
        }
    };

    useEffect(() => {
        handleCommonCodeChange();
        handleAccountChange();
        handleModeOfPayChange();
        if (voucherLineId !== undefined) {
            handleVoucherLineChange(voucherLineId);
        }
        return () => {
            setVoucherLine({});
        }
    }, []);

    return (
        <TableRow
            hover
            key={"action_row"}
            tabIndex={-1}
            role="checkbox"
        >
            {formFields.map((formField, index) => {
                return (
                    <TableCell
                        colSpan={formField.colSpan === undefined ? 1 : formField.colSpan}
                        key={"col" + index}
                    // align={col.align}
                    >
                        <GoInlineField
                            config={formField}
                            values={values}
                            touched={touched}
                            errors={errors}
                            handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
                            onClose={() => onClose()}
                        />
                    </TableCell>
                );
            })}
        </TableRow>
        // <Container>
        //     <Formik
        //         enableReinitialize
        //         initialValues={voucher_line}
        //         validationSchema={schema}
        //         onSubmit={(values) => handleSubmit(values)}
        //     >
        //         {({
        //             values,
        //             touched,
        //             errors,
        //             handleChange,
        //             handleSubmit,
        //         }) => (
        //             <Form noValidate onSubmit={handleSubmit}>
        //                 <StyledDrawerForm>
        //                     <Grid
        //                         container
        //                         maxWidth="md"
        //                         rowSpacing={1}
        //                         columnSpacing={{ xs: 1, sm: 2, md: 2 }}
        //                     >
        //                         {formFields.map((formField, index) => {
        //                             return (
        //                                 <Grid key={index} item xs={12} sm={12} md={6} lg={6}>
        //                                     <GoForm
        //                                         config={formField}
        //                                         values={values}
        //                                         touched={touched}
        //                                         errors={errors}
        //                                         handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
        //                                     />
        //                                 </Grid>
        //                             );
        //                         })}
        //                     </Grid>
        //                     <Box sx={{ p: 2, textAlign: "right" }}>
        //                         <Button
        //                             variant="contained"
        //                             color="error"
        //                             startIcon={<Iconify icon="eva:close-circle-outline" />}
        //                             onClick={() => onClose()}
        //                         >
        //                             Close
        //                         </Button>
        //                         &nbsp;&nbsp;
        //                         {
        //                             ((values.id === undefined && voucherType === "Payment Voucher" && permissions.has(PermissionConstants.PAYMENT_VOUCHER_CREATE)) ||
        //                                 (values.id !== undefined && voucherType === "Payment Voucher" && permissions.has(PermissionConstants.PAYMENT_VOUCHER_UPDATE)) ||
        //                                 (values.id === undefined && voucherType === "Journal Voucher" && permissions.has(PermissionConstants.JOURNAL_VOUCHER_CREATE)) ||
        //                                 (values.id !== undefined && voucherType === "Journal Voucher" && permissions.has(PermissionConstants.JOURNAL_VOUCHER_UPDATE)) ||
        //                                 (values.id === undefined && (voucherType === "Prepayment Voucher" || voucherType === "SplitUp") && permissions.has(PermissionConstants.PREPAYMENT_VOUCHER_CREATE)) ||
        //                                 (values.id !== undefined && (voucherType === "Prepayment Voucher" || voucherType === "SplitUp") && permissions.has(PermissionConstants.PREPAYMENT_VOUCHER_UPDATE))
        //                             ) &&
        //                             <Button
        //                                 variant="contained"
        //                                 startIcon={<Iconify icon="eva:save-fill" />}
        //                                 type="submit"
        //                             >
        //                                 {values.id === undefined ? 'Save' : 'Update'}
        //                             </Button>
        //                         }
        //                     </Box>
        //                     <Divider />


        //                 </StyledDrawerForm>
        //                 <br />
        //             </Form>
        //         )}
        //     </Formik>
        // </Container>
    );
};

VoucherLine.propTypes = {
    voucherId: PropTypes.any,
    voucherLineId: PropTypes.any,
    voucherType: PropTypes.string,
    onClose: PropTypes.any,
};

export default VoucherLine;